import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { CalendarIcon, BrainCircuitIcon, ClockIcon, ShieldCheckIcon, ArrowRightIcon, CalendarDaysIcon, LightbulbIcon, RocketIcon, UsersIcon, HeartIcon } from 'lucide-react';
export function About() {
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-1146">
      <Header data-id="element-1147" />
      <main data-id="element-1148">
        {/* Hero Section */}
        <section className="w-full py-16 md:py-24 px-6 md:px-12 flex flex-col items-center text-center" data-id="element-1149">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 max-w-4xl" data-id="element-1150">
            Meet the Team Behind the Smarter Meeting
          </h1>
          <p className="text-lg md:text-xl text-[#F5F7FA] text-opacity-80 max-w-2xl mb-10" data-id="element-1151">
            We're on a mission to eliminate unproductive meetings by empowering
            professionals with AI-driven context and insights.
          </p>
          <div className="relative w-full max-w-3xl h-64 md:h-80 mb-8" data-id="element-1152">
            <div className="absolute inset-0 bg-[#C8F169] bg-opacity-5 rounded-xl overflow-hidden" data-id="element-1153">
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center" data-id="element-1154">
                <div className="relative" data-id="element-1155">
                  <CalendarIcon className="h-16 w-16 text-[#C8F169] opacity-30 absolute -left-20" data-id="element-1156" />
                  <BrainCircuitIcon className="h-24 w-24 text-[#C8F169]" data-id="element-1157" />
                  <ClockIcon className="h-16 w-16 text-[#C8F169] opacity-30 absolute -right-20" data-id="element-1158" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Our Mission Section */}
        <section className="w-full py-16 px-6 md:px-12 bg-[#1A2331]" data-id="element-1159">
          <div className="max-w-6xl mx-auto" data-id="element-1160">
            <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-1161">
              <div className="md:w-1/2" data-id="element-1162">
                <h2 className="text-3xl font-bold mb-6" data-id="element-1163">Our Mission</h2>
                <p className="text-lg mb-6 text-[#F5F7FA] text-opacity-80" data-id="element-1164">
                  At Prepz.io, we believe every professional deserves to walk
                  into meetings with complete context and clarity. Our mission
                  is to eliminate the wasted hours spent on meeting preparation
                  and the anxiety of being unprepared.
                </p>
                <p className="text-lg mb-8 text-[#F5F7FA] text-opacity-80" data-id="element-1165">
                  We're building intelligent tools that deliver the right
                  information at the right time, helping you make every
                  conversation count—without sacrificing your time or privacy.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-1166">
                  <div className="flex flex-col items-center text-center" data-id="element-1167">
                    <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-3" data-id="element-1168">
                      <ClockIcon className="h-6 w-6 text-[#C8F169]" data-id="element-1169" />
                    </div>
                    <h3 className="font-semibold mb-1" data-id="element-1170">Speed</h3>
                    <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1171">
                      Prep in minutes, not hours
                    </p>
                  </div>
                  <div className="flex flex-col items-center text-center" data-id="element-1172">
                    <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-3" data-id="element-1173">
                      <BrainCircuitIcon className="h-6 w-6 text-[#C8F169]" data-id="element-1174" />
                    </div>
                    <h3 className="font-semibold mb-1" data-id="element-1175">Intelligence</h3>
                    <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1176">
                      Insights, not just information
                    </p>
                  </div>
                  <div className="flex flex-col items-center text-center" data-id="element-1177">
                    <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-3" data-id="element-1178">
                      <ShieldCheckIcon className="h-6 w-6 text-[#C8F169]" data-id="element-1179" />
                    </div>
                    <h3 className="font-semibold mb-1" data-id="element-1180">Privacy</h3>
                    <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1181">
                      Your data stays yours
                    </p>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2" data-id="element-1182">
                <div className="bg-[#F5F7FA] bg-opacity-5 rounded-xl p-8 shadow-lg" data-id="element-1183">
                  <blockquote className="text-xl italic text-[#F5F7FA] mb-6" data-id="element-1184">
                    "We're building Prepz.io to solve a problem we've
                    experienced firsthand—the frustration of walking into
                    meetings unprepared or spending hours researching when you
                    should be focusing on the conversation itself."
                  </blockquote>
                  <div className="flex items-center" data-id="element-1185">
                    <div className="w-12 h-12 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] font-bold mr-4" data-id="element-1186">
                      AJ
                    </div>
                    <div data-id="element-1187">
                      <div className="font-medium" data-id="element-1188">Alex Johnson</div>
                      <div className="text-sm text-[#F5F7FA] text-opacity-60" data-id="element-1189">
                        Co-founder & CEO
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* The Story Behind Prepz.io */}
        <section className="w-full py-16 px-6 md:px-12" data-id="element-1190">
          <div className="max-w-6xl mx-auto" data-id="element-1191">
            <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-1192">
              The Story Behind Prepz.io
            </h2>
            <div className="relative" data-id="element-1193">
              <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#C8F169] bg-opacity-20" data-id="element-1194"></div>
              <div className="relative z-10" data-id="element-1195">
                {/* Timeline Item 1 */}
                <div className="flex flex-col md:flex-row items-center md:items-start mb-16" data-id="element-1196">
                  <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0" data-id="element-1197">
                    <div className="inline-block bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full text-sm mb-3" data-id="element-1198">
                      2021
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-1199">The Problem</h3>
                    <p className="text-[#F5F7FA] text-opacity-80" data-id="element-1200">
                      After spending countless hours preparing for meetings that
                      could have been emails (or better meetings), our
                      founders—veterans of the SaaS industry—decided there had
                      to be a better way.
                    </p>
                  </div>
                  <div className="w-12 h-12 bg-[#1E2A38] border-4 border-[#C8F169] rounded-full flex items-center justify-center z-20 mx-6" data-id="element-1201">
                    <LightbulbIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1202" />
                  </div>
                  <div className="md:w-1/2 md:pl-12 hidden md:block" data-id="element-1203"></div>
                </div>
                {/* Timeline Item 2 */}
                <div className="flex flex-col md:flex-row items-center md:items-start mb-16" data-id="element-1204">
                  <div className="md:w-1/2 md:pr-12 hidden md:block" data-id="element-1205"></div>
                  <div className="w-12 h-12 bg-[#1E2A38] border-4 border-[#C8F169] rounded-full flex items-center justify-center z-20 mx-6" data-id="element-1206">
                    <RocketIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1207" />
                  </div>
                  <div className="md:w-1/2 md:pl-12 mb-6 md:mb-0" data-id="element-1208">
                    <div className="inline-block bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full text-sm mb-3" data-id="element-1209">
                      2022
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-1210">The Launch</h3>
                    <p className="text-[#F5F7FA] text-opacity-80" data-id="element-1211">
                      Prepz.io was born with a simple premise: what if AI could
                      gather all the context you need before a meeting, so you
                      could focus on the human connection? Our beta launched
                      with a waitlist that grew to 5,000 users in just two
                      weeks.
                    </p>
                  </div>
                </div>
                {/* Timeline Item 3 */}
                <div className="flex flex-col md:flex-row items-center md:items-start mb-16" data-id="element-1212">
                  <div className="md:w-1/2 md:pr-12 md:text-right mb-6 md:mb-0" data-id="element-1213">
                    <div className="inline-block bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full text-sm mb-3" data-id="element-1214">
                      2023
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-1215">The Growth</h3>
                    <p className="text-[#F5F7FA] text-opacity-80" data-id="element-1216">
                      After securing seed funding, we expanded our team and
                      product capabilities. Our users reported saving an average
                      of 5 hours per week on meeting prep while feeling more
                      confident and prepared.
                    </p>
                  </div>
                  <div className="w-12 h-12 bg-[#1E2A38] border-4 border-[#C8F169] rounded-full flex items-center justify-center z-20 mx-6" data-id="element-1217">
                    <UsersIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1218" />
                  </div>
                  <div className="md:w-1/2 md:pl-12 hidden md:block" data-id="element-1219"></div>
                </div>
                {/* Timeline Item 4 */}
                <div className="flex flex-col md:flex-row items-center md:items-start" data-id="element-1220">
                  <div className="md:w-1/2 md:pr-12 hidden md:block" data-id="element-1221"></div>
                  <div className="w-12 h-12 bg-[#1E2A38] border-4 border-[#C8F169] rounded-full flex items-center justify-center z-20 mx-6" data-id="element-1222">
                    <HeartIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1223" />
                  </div>
                  <div className="md:w-1/2 md:pl-12" data-id="element-1224">
                    <div className="inline-block bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-full text-sm mb-3" data-id="element-1225">
                      Today
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-1226">The Future</h3>
                    <p className="text-[#F5F7FA] text-opacity-80" data-id="element-1227">
                      Today, Prepz.io is used by thousands of professionals
                      across industries. We're just getting started on our
                      mission to make every meeting worth the calendar space it
                      takes up.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Meet the Team */}
        <section className="w-full py-16 px-6 md:px-12 bg-[#1A2331]" data-id="element-1228">
          <div className="max-w-6xl mx-auto" data-id="element-1229">
            <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-1230">
              Meet the Team
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1231">
              {/* Team Member 1 */}
              <div className="bg-[#1E2A38] rounded-xl overflow-hidden shadow-lg" data-id="element-1232">
                <div className="p-6 flex flex-col items-center text-center" data-id="element-1233">
                  <div className="w-24 h-24 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold mb-4" data-id="element-1234">
                    AJ
                  </div>
                  <h3 className="text-xl font-bold mb-1" data-id="element-1235">Alex Johnson</h3>
                  <p className="text-[#C8F169] mb-4" data-id="element-1236">Co-founder & CEO</p>
                  <p className="text-[#F5F7FA] text-opacity-80 mb-4" data-id="element-1237">
                    Former VP of Product at MeetingPro. Alex has spent 15+ years
                    building tools that help teams work better together.
                  </p>
                  <div className="flex space-x-4" data-id="element-1238">
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1239">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1240">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-1241" />
                      </svg>
                    </a>
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1242">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1243">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1244" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              {/* Team Member 2 */}
              <div className="bg-[#1E2A38] rounded-xl overflow-hidden shadow-lg" data-id="element-1245">
                <div className="p-6 flex flex-col items-center text-center" data-id="element-1246">
                  <div className="w-24 h-24 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold mb-4" data-id="element-1247">
                    SL
                  </div>
                  <h3 className="text-xl font-bold mb-1" data-id="element-1248">Sarah Lee</h3>
                  <p className="text-[#C8F169] mb-4" data-id="element-1249">Co-founder & CTO</p>
                  <p className="text-[#F5F7FA] text-opacity-80 mb-4" data-id="element-1250">
                    AI researcher and engineering leader with experience at
                    Google and OpenAI. Sarah is passionate about making AI
                    accessible and useful.
                  </p>
                  <div className="flex space-x-4" data-id="element-1251">
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1252">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1253">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-1254" />
                      </svg>
                    </a>
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1255">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1256">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1257" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              {/* Team Member 3 */}
              <div className="bg-[#1E2A38] rounded-xl overflow-hidden shadow-lg" data-id="element-1258">
                <div className="p-6 flex flex-col items-center text-center" data-id="element-1259">
                  <div className="w-24 h-24 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold mb-4" data-id="element-1260">
                    MR
                  </div>
                  <h3 className="text-xl font-bold mb-1" data-id="element-1261">Marcus Rodriguez</h3>
                  <p className="text-[#C8F169] mb-4" data-id="element-1262">Head of Design</p>
                  <p className="text-[#F5F7FA] text-opacity-80 mb-4" data-id="element-1263">
                    Previously led design at Calendly and Zoom. Marcus is
                    obsessed with creating interfaces that feel intuitive and
                    disappear when you use them.
                  </p>
                  <div className="flex space-x-4" data-id="element-1264">
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1265">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1266">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-1267" />
                      </svg>
                    </a>
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1268">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1269">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1270" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              {/* Team Member 4 */}
              <div className="bg-[#1E2A38] rounded-xl overflow-hidden shadow-lg" data-id="element-1271">
                <div className="p-6 flex flex-col items-center text-center" data-id="element-1272">
                  <div className="w-24 h-24 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold mb-4" data-id="element-1273">
                    JD
                  </div>
                  <h3 className="text-xl font-bold mb-1" data-id="element-1274">Jessica Diaz</h3>
                  <p className="text-[#C8F169] mb-4" data-id="element-1275">VP of Customer Success</p>
                  <p className="text-[#F5F7FA] text-opacity-80 mb-4" data-id="element-1276">
                    With over a decade in SaaS customer success roles, Jessica
                    ensures our users get maximum value from Prepz.io from day
                    one.
                  </p>
                  <div className="flex space-x-4" data-id="element-1277">
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1278">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1279">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-1280" />
                      </svg>
                    </a>
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1281">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1282">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1283" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              {/* Team Member 5 */}
              <div className="bg-[#1E2A38] rounded-xl overflow-hidden shadow-lg" data-id="element-1284">
                <div className="p-6 flex flex-col items-center text-center" data-id="element-1285">
                  <div className="w-24 h-24 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold mb-4" data-id="element-1286">
                    KT
                  </div>
                  <h3 className="text-xl font-bold mb-1" data-id="element-1287">Kevin Thompson</h3>
                  <p className="text-[#C8F169] mb-4" data-id="element-1288">Lead Engineer</p>
                  <p className="text-[#F5F7FA] text-opacity-80 mb-4" data-id="element-1289">
                    Full-stack engineer with expertise in AI integrations and
                    scalable architecture. Kevin previously built systems at
                    Asana and Notion.
                  </p>
                  <div className="flex space-x-4" data-id="element-1290">
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1291">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1292">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-1293" />
                      </svg>
                    </a>
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1294">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1295">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1296" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              {/* Team Member 6 */}
              <div className="bg-[#1E2A38] rounded-xl overflow-hidden shadow-lg" data-id="element-1297">
                <div className="p-6 flex flex-col items-center text-center" data-id="element-1298">
                  <div className="w-24 h-24 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xl font-bold mb-4" data-id="element-1299">
                    PL
                  </div>
                  <h3 className="text-xl font-bold mb-1" data-id="element-1300">Priya Lakshmi</h3>
                  <p className="text-[#C8F169] mb-4" data-id="element-1301">Director of Marketing</p>
                  <p className="text-[#F5F7FA] text-opacity-80 mb-4" data-id="element-1302">
                    B2B marketing strategist who has helped scale multiple SaaS
                    startups from seed to Series B and beyond. Data-driven and
                    customer-obsessed.
                  </p>
                  <div className="flex space-x-4" data-id="element-1303">
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1304">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1305">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-1306" />
                      </svg>
                    </a>
                    <a href="#" className="text-[#F5F7FA] text-opacity-60 hover:text-[#C8F169]" data-id="element-1307">
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-1308">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1309" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Trusted By Section */}
        <section className="w-full py-16 px-6 md:px-12" data-id="element-1310">
          <div className="max-w-6xl mx-auto" data-id="element-1311">
            <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-1312">Trusted By</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center" data-id="element-1313">
              <div className="flex justify-center" data-id="element-1314">
                <div className="h-12 text-[#F5F7FA] text-opacity-70 font-bold text-xl" data-id="element-1315">
                  ACME Corp
                </div>
              </div>
              <div className="flex justify-center" data-id="element-1316">
                <div className="h-12 text-[#F5F7FA] text-opacity-70 font-bold text-xl" data-id="element-1317">
                  TechGiant
                </div>
              </div>
              <div className="flex justify-center" data-id="element-1318">
                <div className="h-12 text-[#F5F7FA] text-opacity-70 font-bold text-xl" data-id="element-1319">
                  FutureCo
                </div>
              </div>
              <div className="flex justify-center" data-id="element-1320">
                <div className="h-12 text-[#F5F7FA] text-opacity-70 font-bold text-xl" data-id="element-1321">
                  Innovate Inc
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Careers / Join Us CTA */}
        <section className="w-full py-16 px-6 md:px-12 bg-[#1A2331]" data-id="element-1322">
          <div className="max-w-4xl mx-auto" data-id="element-1323">
            <div className="bg-[#1E2A38] rounded-xl p-8 md:p-12 shadow-lg" data-id="element-1324">
              <div className="flex flex-col md:flex-row items-center" data-id="element-1325">
                <div className="md:w-2/3 mb-8 md:mb-0 md:pr-8" data-id="element-1326">
                  <h2 className="text-3xl font-bold mb-4" data-id="element-1327">Join Our Team</h2>
                  <p className="text-lg text-[#F5F7FA] text-opacity-80 mb-6" data-id="element-1328">
                    We're just getting started — come help us build the future
                    of meetings. We're looking for passionate people who want to
                    make work better for everyone.
                  </p>
                  <Button data-id="element-1329">
                    View Open Positions{' '}
                    <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-1330" />
                  </Button>
                </div>
                <div className="md:w-1/3" data-id="element-1331">
                  <div className="w-full h-40 bg-[#C8F169] bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-1332">
                    <div className="w-16 h-16 bg-[#C8F169] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-1333">
                      <RocketIcon className="h-8 w-8 text-[#C8F169]" data-id="element-1334" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1335" />
    </div>;
}